// @ts-nocheck

import { request } from '../context';
import type { ApiOptions } from '../context';
import type {
    GetTranslateTerminologyConfigsQuery,
    BaseResponseListTranslateTerminologyConfigFoundResponse,
    PostTranslateTerminologyConfigsBody,
    BaseResponseTranslateTerminologyConfigFoundResponse,
} from '../types';

/**
 * 列表
 *
 * @export
 * @tags translate-terminology-config-controller
 * @link [GET] /translateTerminologyConfigs
 */
export function getTranslateTerminologyConfigs(): Promise<BaseResponseListTranslateTerminologyConfigFoundResponse>;
export function getTranslateTerminologyConfigs(
    options: ApiOptions<never, GetTranslateTerminologyConfigsQuery>
): Promise<BaseResponseListTranslateTerminologyConfigFoundResponse>;
export function getTranslateTerminologyConfigs(
    options?: ApiOptions<never, GetTranslateTerminologyConfigsQuery>
): Promise<BaseResponseListTranslateTerminologyConfigFoundResponse> {
    return request<never, never, GetTranslateTerminologyConfigsQuery>(
        '/translateTerminologyConfigs',
        { ...options, method: 'get', __$requestCalleeName: 'getTranslateTerminologyConfigs' }
    );
}

/**
 * 新增
 *
 * @export
 * @tags translate-terminology-config-controller
 * @link [POST] /translateTerminologyConfigs
 */
export function postTranslateTerminologyConfigs(
    data: PostTranslateTerminologyConfigsBody
): Promise<BaseResponseTranslateTerminologyConfigFoundResponse>;
export function postTranslateTerminologyConfigs(
    data: PostTranslateTerminologyConfigsBody,
    options: ApiOptions<never, never>
): Promise<BaseResponseTranslateTerminologyConfigFoundResponse>;
export function postTranslateTerminologyConfigs(
    data: PostTranslateTerminologyConfigsBody,
    options?: ApiOptions<never, never>
): Promise<BaseResponseTranslateTerminologyConfigFoundResponse> {
    return request<PostTranslateTerminologyConfigsBody, never, never>(
        '/translateTerminologyConfigs',
        {
            ...options,
            data,
            method: 'post',
            __$requestCalleeName: 'postTranslateTerminologyConfigs',
        }
    );
}

export const meta = [
    {
        tags: ['translate-terminology-config-controller'],
        path: '/translateTerminologyConfigs',
        method: 'get',
    },
    {
        tags: ['translate-terminology-config-controller'],
        path: '/translateTerminologyConfigs',
        method: 'post',
    },
];
